// extracted by mini-css-extract-plugin
module.exports = {"collection-search-actions":"all-items-inspector_collection-search-actions__3H17Z","collection-search-bar":"all-items-inspector_collection-search-bar__2u_Fs"};